import React from 'react';
export function HowItWorks() {
  return <section className="bg-white-soft section-padding" data-id="element-138">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-139">
        Cómo funciona en 3 simples pasos
      </h2>

      <div className="relative max-w-4xl mx-auto" data-id="element-140">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-20 right-20 h-1 bg-gold/30 z-0" data-id="element-141"></div>

        <div className="grid md:grid-cols-3 gap-12 relative z-10" data-id="element-142">
          <div className="text-center" data-id="element-143">
            <div className="w-24 h-24 bg-navy text-white rounded-full flex items-center justify-center text-4xl font-bold mx-auto mb-6 shadow-lg border-4 border-white" data-id="element-144">
              1
            </div>
            <h3 className="text-xl font-bold mb-4" data-id="element-145">Descarga y Lee</h3>
            <p className="text-gray-600" data-id="element-146">
              Descarga el manual y dedica solo 45 minutos a leerlo en un
              lenguaje claro y sencillo.
            </p>
          </div>

          <div className="text-center" data-id="element-147">
            <div className="w-24 h-24 bg-navy text-white rounded-full flex items-center justify-center text-4xl font-bold mx-auto mb-6 shadow-lg border-4 border-white" data-id="element-148">
              2
            </div>
            <h3 className="text-xl font-bold mb-4" data-id="element-149">Configura</h3>
            <p className="text-gray-600" data-id="element-150">
              Sigue las instrucciones para activar los "Contactos de Legado" en
              tus cuentas actuales.
            </p>
          </div>

          <div className="text-center" data-id="element-151">
            <div className="w-24 h-24 bg-gold text-white rounded-full flex items-center justify-center text-4xl font-bold mx-auto mb-6 shadow-lg border-4 border-white" data-id="element-152">
              3
            </div>
            <h3 className="text-xl font-bold mb-4" data-id="element-153">Imprime y Guarda</h3>
            <p className="text-gray-600" data-id="element-154">
              Imprime tu Hoja de Ruta, llénala y guárdala en un lugar seguro que
              tu familia conozca.
            </p>
          </div>
        </div>
      </div>
    </section>;
}